import {
  SALESPUBLIC_LOADING,
  GET_SALESPUBLIC,
  GET_SALESPUBLIC_ONE,
  GET_SALESPUBLIC_SUCCESS,
  GET_SALESPUBLIC_FAIL,
  ADD_SALESPUBLIC_SUCCESS,
  ADD_SALESPUBLIC_FAIL,
  DELETE_SALESPUBLIC_SUCCESS,
  DELETE_SALESPUBLIC_FAIL,
  UPDATE_SALESPUBLIC_SUCCESS,
  UPDATE_SALESPUBLIC_FAIL,
  SALESPUBLIC_RESET
} from "./actionType";

const INIT_STATE = {
  salesPublics: [],
  salesPublicOne: {},
  salesPublicAdded: {},
  error: {},
};

const SalesPublic = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_SALESPUBLIC_SUCCESS:
      switch (action.payload.actionType) {
        case GET_SALESPUBLIC:
          return {
            ...state,
            salesPublics: action.payload.data,
            isSalesPublicCreated: false,
            isSalesPublicSuccess: true,
            loading: false,
          };

        case GET_SALESPUBLIC_ONE:
          return {
            ...state,
            salesPublicOne: action.payload.data,
            isSalesPublicSuccess: true,
            loading: false,
          };

        default:
          return { ...state };
      }
    case GET_SALESPUBLIC_FAIL:
      switch (action.payload.actionType) {
        case GET_SALESPUBLIC_FAIL:
          return {
            ...state,
            error: action.payload.error,
            isSalesPublicCreated: false,
            isSalesPublicSuccess: false,
            loading: false,
          };
        default:
          return { ...state };
      }

    case GET_SALESPUBLIC: {
      return {
        ...state,
        isSalesPublicCreated: false,
        loading: true,
      };
    }

    case GET_SALESPUBLIC_ONE: {
      return {
        ...state,
        salesPublicOne: action.payload.data,
        isSalesPublicCreated: false,
        loading: true,
      };
    }

    case SALESPUBLIC_LOADING: {
      return {
        ...state,
        isSalesPublicCreated: false,
        loading: true,
      };
    }

    case ADD_SALESPUBLIC_SUCCESS:
      return {
        ...state,
        isSalesPublicCreated: true,
        loading: false,
        salesPublics: [action.payload.data, ...state.salesPublics],
        salesPublicAdded: action.payload.data
      };

    case ADD_SALESPUBLIC_FAIL:
      return {
        ...state,
        loading: false,
        isSalesPublicCreated: false,
        error: action.payload,
      };

    case DELETE_SALESPUBLIC_SUCCESS:
      return {
        ...state,
        loading: false,
        salesPublics: state.salesPublics.filter(
          salesPublics => salesPublics.id.toString() !== action.payload.id.toString()
        ),
      };

    case DELETE_SALESPUBLIC_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case UPDATE_SALESPUBLIC_SUCCESS:
      return {
        ...state,
        loading: false,
        isSalesPublicCreated: true,
        salesPublics: state.salesPublics.map(salesPublics =>
          salesPublics.id.toString() === action.payload.data.id.toString() ? { ...salesPublics, ...action.payload.data } : salesPublics
        ),
        salesPublicAdded: action.payload.data
      };

    case UPDATE_SALESPUBLIC_FAIL:
      return {
        ...state,
        loading: false,
        isSalesPublicCreated: false,
        error: action.payload,
      };

    case SALESPUBLIC_RESET:
      return INIT_STATE;

    default:
      return { ...state };
  }
};

export default SalesPublic;